import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Everything on the Customers page waiting for a human: pending actions plus
 * AI relationship suggestions. Drives the badge on the sidebar's Customers item.
 */
export function useCustomerReviewCount(businessId: string | null | undefined) {
  const { data } = useQuery({
    queryKey: ["customer-review-count", businessId],
    enabled: !!businessId,
    refetchInterval: 60_000,
    queryFn: async () => {
      const db = supabase as any;
      const [approvals, suggestions] = await Promise.all([
        db
          .from("action_approval_queue")
          .select("id", { count: "exact", head: true })
          .eq("business_id", businessId)
          .eq("status", "pending")
          .neq("action_name", "winback_batch"),
        db
          .from("customer_relationships")
          .select("relationship_id", { count: "exact", head: true })
          .eq("business_id", businessId)
          .in("state", ["inferred", "possible"]),
      ]);
      if (approvals.error) throw approvals.error;
      if (suggestions.error) throw suggestions.error;
      return {
        approvals: (approvals.count ?? 0) as number,
        suggestions: (suggestions.count ?? 0) as number,
      };
    },
  });
  return data ?? { approvals: 0, suggestions: 0 };
}
